import { render, staticRenderFns } from "./filesOperate.vue?vue&type=template&id=5068d6b8&scoped=true&"
import script from "./filesOperate.vue?vue&type=script&lang=js&"
export * from "./filesOperate.vue?vue&type=script&lang=js&"
import style0 from "./filesOperate.vue?vue&type=style&index=0&id=5068d6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068d6b8",
  null
  
)

export default component.exports